<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row justify-content-center min-vh-100">
            <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-5">
                <div class="card" style="max-width: 600px; margin: 0 auto;">
                    <div class="d-flex justify-content-end mr-2 mt-1">
                        <LanguageSwitcher />
                    </div>

                    <div class="card-body">
                        <div class="card-header"></div>
                        <div>
                            <div class="mb-5 text-center">
                                <CompanyImage :type="CompanyImageType.Logo" max-height="140px" max-width="100%" />
                            </div>

                            <div v-if="!message">
                                <ForgotPasswordForm
                                    :initial-values="request"
                                    id="forgot-password-form"
                                    @submit="submitResetLink"
                                    @clear-error="error = null"
                                />
                                <div class="mt-4">
                                    <button
                                        type="submit"
                                        form="forgot-password-form"
                                        class="btn btn-block btn-primary"
                                    >
                                        {{ $t('register.forgot_password_title') }}
                                    </button>
                                </div>
                            </div>
                            <div class="mt-5" v-if="message || errors.length || errormessage">
                                <div class="alert alert-success" v-if="message">
                                    {{ $t('register.success_email_sent_message') }}
                                </div>
                                <div class="alert alert-danger" v-if="errors.length">
                                    <ul>
                                        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                                    </ul>
                                </div>
                                <div class="alert alert-danger" v-if="errormessage">
                                    {{ $t('register.error_message') }} {{ errormessage }}
                                </div>
                            </div>
                            <div v-if="!message" class="mt-3 text-center">
                                <router-link to="/login">{{ $t('register.login_link') }}</router-link>
                                <span v-if="isLiteVersion">|</span>
                                <router-link v-if="isLiteVersion" to="/register">{{ $t('register.register_link') }}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import ForgotPasswordForm from '../forms/ForgotPasswordForm.vue';
    import LanguageSwitcher from '../components/LanguageSwitcher.vue';
    import { AccountService } from '../services/accountService';
    import CompanyImage from './CompanyImage.vue';
    import { CompanyImageType } from '../enums/company-image-type';

    export default {
        components: {
            CompanyImage,
            LanguageSwitcher,
            ForgotPasswordForm
        },
        data() {
            return {
                request: {
                    email: '',
                },

                message: null,
                errormessage: null,
                errors: [],
            };
        },
        computed: {
            CompanyImageType() {
                return CompanyImageType
            },
            isLiteVersion() {
                return window.IS_LITE_VERSION;
            },
        },
        methods: {
            async submitResetLink(data) {
                try {
                    const response = await AccountService.getInstance().sendPasswordResetLink(data.email);
                    this.message = response.data.message;
                } catch (exception) {
                    this.handleErrorResponse(exception.response);
                }
            },
            handleErrorResponse(response) {
                if (response.status === 404) {
                    this.errormessage = 'Gebruiker niet gevonden: Controleer uw e-mailadres en probeer het opnieuw.';
                } else if (response.status === 422) {
                    this.errors = Object.values(response.data.errors).flat();
                } else {
                    this.errormessage = 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.';
                }
            }
        }
    };
</script>
